import React from "react";
import PropTypes from "prop-types";
import CircularProgressbar from "react-circular-progressbar";
import { UncontrolledTooltip } from "reactstrap";

class Student extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const isActive = this.props.isActive ? "student-profile active" : "student-profile";

    return (
      <div className={isActive}>
        <div className="profile-picture" />
        <CircularProgressbar percentage={this.props.percentage} strokeWidth={50} textForPercentage={(pct) => ""} />
        <div className="student-name">
          {this.props.name}{" "}
          {this.props.employerSpecific && (
            <small className="student-name__property">
              (Bedrijfsspecifiek)
              <span className="show-tooltip show-tooltip--inline show-tooltip--primary" id={"tooltiptrigger" + this.props.uuid}>
                <i className="fa fa-info-circle" />
              </span>
              <UncontrolledTooltip
                placement="right"
                target={"tooltiptrigger" + this.props.uuid}
                className="measurement-tooltip measurement-tooltip--align-left measurement-tooltip--wider"
              >
                De opleider heeft deze cursist aangemeld voor bedrijfsspecifieke competentie en certificering.
                <br />
                <br />
                <strong>Let op:</strong> deze competentie wordt niet getoond in NIBHV Praktijk.
              </UncontrolledTooltip>
            </small>
          )}
        </div>
      </div>
    );
  }
}

Student.propTypes = {
  isActive: PropTypes.bool,
  name: PropTypes.string
};

export default Student;



// WEBPACK FOOTER //
// ./components/Student.js